// extracted by mini-css-extract-plugin
export default {"SwitchTabs":"SwitchTabs_SwitchTabs__WS6bq","selected":"SwitchTabs_selected__GodW3"};